import React from 'react';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const buyData = payload.find(data => data.dataKey === 'BUY');
    const sellData = payload.find(data => data.dataKey === 'SELL');

    return (
      <div className="bg-white p-4 border border-gray-300 rounded-lg shadow-lg">
        <p className="font-bold mb-2">{`Date: ${label}`}</p>
        <div className="flex flex-col">
          <div className="flex justify-between mb-1">
            <span className="font-semibold">BUY:</span>
            <span>{`${Number(buyData.value !== 0 ? buyData.payload.total : '0.00').toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${buyData.payload.currencySymbol} @ (${Number(buyData.payload.rate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${buyData.payload.rateCurrencySymbol}/${buyData.payload.currencySymbol})`}</span>
          </div>
          <div className="flex justify-between mb-1">
            <span className="font-semibold">SELL:</span>
            <span>{` ${Number(sellData.value !== 0 ? sellData.payload.total : '0.00').toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${sellData.payload.currencySymbol} @ (${Number(sellData.payload.rate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${buyData.payload.rateCurrencySymbol}/${buyData.payload.currencySymbol})`}</span>
          </div>
          {/* <div className="flex justify-between">
            <span className="font-semibold">Description:</span>
            <span>{buyData.payload.remark}</span>
          </div> */}
        </div>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
